export default __webpack_public_path__ + "static/media/misc-books2-1440w.7cb2e537.webp";